import {
  Button,
  CircularProgress,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemText,
  ListSubheader,
  TextField,
  Typography,
} from '@material-ui/core';
import {getCaseNamesByCaseNumber, updateCaseName} from 'BOSTools/ducks/bosTools';
import {CaseName} from 'BOSTools/models/CaseName';
import {isLoaded, ServerError} from 'Core/models/Async';
import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import './BOSTools.sass';

const CaseNameUpdate = () => {
  const dispatch = useDispatch();

  const {caseNames} = useSelector((state: ReducerState) => state.bostools);
  const [caseNumber, setCaseNumber] = useState(isLoaded(caseNames) ? caseNames.Data[0]?.caseNumber : '');
  const [selectedCaseName, setSelectedCaseName] = useState<CaseName>();

  useEffect(() => {
    if (isLoaded(caseNames) && caseNames.Data.length === 1) {
      setSelectedCaseName(caseNames.Data[0]);
    }
  }, [caseNames]);

  return (
    <Grid container direction="column" spacing={4}>
      <>
        <Grid item>
          <TextField
            id="caseNumber"
            fullWidth
            variant="outlined"
            label="Case Number"
            value={caseNumber}
            onChange={e => setCaseNumber(e.target.value)}
            required
          />
        </Grid>
        <Grid item container justify="flex-end">
          <Button
            color="primary"
            variant="contained"
            disabled={!caseNumber}
            onClick={() => {
              dispatch(getCaseNamesByCaseNumber(caseNumber!));
              setSelectedCaseName(undefined);
            }}
          >
            Search
          </Button>
        </Grid>
        {isLoaded(caseNames) ? (
          selectedCaseName ? (
            <>
              <Grid item>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Case Number"
                  value={selectedCaseName.caseNumber}
                  disabled
                />
              </Grid>
              <Grid item>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Case Name"
                  inputProps={{maxLength: 50}}
                  required
                  value={selectedCaseName.caseName || ''}
                  onChange={e => setSelectedCaseName({...selectedCaseName, caseName: e.target.value})}
                />
              </Grid>
              <Grid item container justify="flex-end">
                <Button
                  color="primary"
                  variant="contained"
                  disabled={!selectedCaseName.caseName}
                  onClick={() => dispatch(updateCaseName(selectedCaseName))}
                >
                  Update
                </Button>
              </Grid>
            </>
          ) : (
            <List
              subheader={
                <ListSubheader component="div" disableSticky>
                  Please Choose An Item From The List To Update
                </ListSubheader>
              }
            >
              <Divider component="hr" />
              {caseNames.Data.map(cn => (
                <ListItem key={cn.groupID} button onClick={() => setSelectedCaseName(cn)}>
                  <ListItemText
                    primary={<Typography className="bostools_right_margin">CaseName: {cn.caseName}</Typography>}
                  />
                </ListItem>
              ))}
            </List>
          )
        ) : caseNames.key === 'Loading' ? (
          <div className="bostools_form__loading-container">
            <CircularProgress color="primary" />
          </div>
        ) : (
          ['ServerError', 'NotFound'].includes(caseNames.key) && (
            <Grid item>
              <Typography variant="body1">
                {(caseNames as ServerError).errorDetails || (caseNames as ServerError).message}
              </Typography>
            </Grid>
          )
        )}
      </>
    </Grid>
  );
};

export default CaseNameUpdate;
